import React from "react";
import { Sparkles, BarChart3, Shield, Users } from "lucide-react";
import theme from "../../styles/theme";

const T = theme.colors;

export default function Hero() {
  return (
    <div style={{
      background: `linear-gradient(180deg, ${T.deep} 0%, ${T.midnight} 100%)`,
      padding: "48px 24px 40px", textAlign: "center",
      position: "relative", overflow: "hidden",
    }}>
      {/* Glow */}
      <div style={{
        position: "absolute", top: -40, left: "50%", transform: "translateX(-50%)",
        width: 600, height: 600,
        background: `radial-gradient(circle, ${T.purple}15 0%, transparent 70%)`,
        pointerEvents: "none",
      }} />

      <div style={{ position: "relative", zIndex: 1 }} className="fade-in-up">
        {/* Badge */}
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          padding: "6px 16px", borderRadius: 20,
          background: T.purple + "20", border: `1px solid ${T.purple}40`,
          marginBottom: 20,
        }}>
          <Sparkles size={14} color="#fbbf24" />
          <span style={{ fontSize: 11, color: T.accent, fontFamily: theme.fonts.mono, letterSpacing: 2, textTransform: "uppercase" }}>
            Infrastructure Research Intelligence
          </span>
          <Sparkles size={14} color="#fbbf24" />
        </div>

        {/* Headline */}
        <h1 style={{
          fontSize: "clamp(28px, 4vw, 42px)", fontWeight: 800, color: "#fff",
          letterSpacing: "-0.03em", lineHeight: 1.2,
          maxWidth: 700, margin: "0 auto 12px",
        }}>
          The data NYC educators need.
          <br />
          <span style={{ color: T.violet }}>No spin. No agenda.</span>
        </h1>

        {/* Sub */}
        <p style={{
          fontSize: "clamp(14px, 2vw, 16px)", color: T.textMuted,
          lineHeight: 1.6, maxWidth: 550, margin: "0 auto 24px",
        }}>
          Wyzcon Intelligence monitors education policy, contract data, workforce trends,
          and budget allocations &mdash; then translates it into clear analysis for the people
          who actually work in schools.
        </p>

        {/* Feature pills */}
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 16,
          padding: "10px 20px", borderRadius: 10,
          background: T.surface, border: `1px solid ${T.border}`,
          fontSize: 12, color: T.textDim, fontFamily: theme.fonts.mono,
        }}>
          <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <BarChart3 size={13} color={T.accent} /> Real-time analysis
          </span>
          <span style={{ color: T.border }}>|</span>
          <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <Shield size={13} color={T.green} /> Source-verified data
          </span>
          <span style={{ color: T.border }}>|</span>
          <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <Users size={13} color={T.violet} /> Community-driven
          </span>
        </div>
      </div>
    </div>
  );
}
